import {
    LayoutDashboard,
    Calendar,
    Layers,
    Ticket,
    MapPin,
    Smartphone,
    BarChart3,
    Users,
    HelpCircle,
    Clipboard
} from 'lucide-vue-next'
import type { Component } from 'vue'
import type { InstanceUserRightsType } from '@/graphql/generated/sdk'

// Narrow union of right-name keys we use for nav gating.
// Excludes id/instance/user/primary/bzucoAdmin from InstanceUserRightsType.
// Constrained to keyof InstanceUserRightsType so a typo here is a compile error.
export type RightName = keyof InstanceUserRightsType &
    (
        | 'allowManageUsers'
        | 'allowManageEvents'
        | 'allowManageTicketsets'
        | 'allowManageTickets'
        | 'allowManageDevices'
        | 'allowStats'
    )

export interface NavItem {
    key: string
    labelKey: string
    icon: Component
    to: string
    requiredRight?: RightName
}

export interface NavGroup {
    key: string
    labelKey: string
    items: NavItem[]
}

export const navGroups: NavGroup[] = [
    {
        key: 'overview',
        labelKey: 'nav.groups.overview',
        items: [
            { key: 'dashboard', labelKey: 'nav.dashboard', icon: LayoutDashboard, to: '/' },
            { key: 'statistics', labelKey: 'nav.statistics', icon: BarChart3, to: '/statistics', requiredRight: 'allowStats' },
            { key: 'help', labelKey: 'nav.help', icon: HelpCircle, to: '/help' }
        ]
    },
    {
        key: 'tickets',
        labelKey: 'nav.groups.tickets',
        items: [
            { key: 'events', labelKey: 'nav.events', icon: Calendar, to: '/events', requiredRight: 'allowManageEvents' },
            {
                key: 'ticketsets',
                labelKey: 'nav.ticketsets',
                icon: Layers,
                to: '/ticketsets',
                requiredRight: 'allowManageTicketsets'
            },
            { key: 'tickets', labelKey: 'nav.tickets', icon: Ticket, to: '/tickets', requiredRight: 'allowManageTickets' },
            { key: 'zones', labelKey: 'nav.zones', icon: MapPin, to: '/zones' }
        ]
    },
    {
        key: 'settings',
        labelKey: 'nav.groups.settings',
        items: [
            { key: 'devices', labelKey: 'nav.devices', icon: Smartphone, to: '/devices', requiredRight: 'allowManageDevices' },
            { key: 'users', labelKey: 'nav.users', icon: Users, to: '/users', requiredRight: 'allowManageUsers' },
            { key: 'clipboard', labelKey: 'nav.clipboard', icon: Clipboard, to: '/clipboard' }
        ]
    }
]

// Flat list — useful for active-key lookup or any code that wants a single iterable.
export const navItems: NavItem[] = navGroups.flatMap(g => g.items)
